<template>
<v-dialog persistent scrollable v-model="accounts.modals.info" width="950">
<v-card>

<v-snackbar v-model="sb.sb" :color="sb.color" center top absolute :timeout="2000">
<span style="color:white">{{sb.text}}</span>
<v-btn dark flat @click="sb.sb = false"> ОК </v-btn>
</v-snackbar>


<v-toolbar dark  color="#273C51" flat  height="42">
<v-toolbar-title  >   {{accounts.accGroups.selected.title}} </v-toolbar-title>
<v-spacer></v-spacer>
<v-icon @click=" accounts.modals.info = false">mdi-close</v-icon>
</v-toolbar>
<v-card-text style="min-height:80vh">
<b-tabs   card>

<!--Лимиты-->
<b-tab>
<template #title>
<v-icon small color="green">mdi-worker</v-icon> <strong style="margin-left:5px">Лимиты</strong>
</template>

<v-data-table
no-data-text="Информация о лимитах недоступна"
:headers="headers"
:items="desserts"
item-key="name"
hide-actions
ma-0 pa-0
>

<template slot="items" slot-scope="props"   >
<tr>
<td>{{ props.item.name }}</td>
<td class="text-xs-left">{{ props.item.max }}</td>
<td class="text-xs-left">{{ props.item.counter }}</td>
<td class="text-xs-left"> <span v-if="props.item.limit > 0">{{ props.item.limit}}</span><span v-else >Нет</span></td>
<td class="text-xs-left">
<span v-if="props.item.expire">{{ props.item.expire | dateFormat}}</span>
<span v-else>Нет</span>
</td>
</tr>
</template>
</v-data-table>
</b-tab>
<!--Параметры-->
<b-tab>
<template #title>
<v-icon small color="#273C51">mdi-tune</v-icon> <strong style="margin-left:5px">Параметры</strong>
</template>

<v-text-field v-model="accounts.accGroups.selected.info['logian:pass']" label="Логин и пароль" hint="Логин и пароль через : - двоеточие">
<template slot="append">
<v-tooltip top>
<span>Сохранить изменения</span>
<v-btn :disabled="disabled.pass" @click="save('pass')" slot="activator" small icon style="margin:3px">
<v-icon color="green">mdi-content-save</v-icon>
</v-btn>
</v-tooltip>
</template>
</v-text-field>

<v-text-field v-model="accounts.accGroups.selected.info['token_api']" label="Access Token" hint="Токен АПИ вконтакте">
<template slot="append">
<v-tooltip top>
<span>Сохранить изменения</span>
<v-btn :disabled="disabled.pass" @click="save('token_api')" slot="activator" small icon style="margin:3px">
<v-icon color="green">mdi-content-save</v-icon>
</v-btn>
</v-tooltip>
</template>
</v-text-field>

<v-text-field v-model="accounts.accGroups.selected.info['proxy']" label="Прокси" hint="Привязанный прокси">
<template slot="append">
<v-tooltip top>
<span>Сохранить изменения</span>
<v-btn :disabled="disabled.pass" @click="save('proxy')" slot="activator" small icon style="margin:3px">
<v-icon color="green">mdi-content-save</v-icon>
</v-btn>
</v-tooltip>
</template>
</v-text-field>

<v-checkbox @change="save('task_able')" hide-details  color="#232F3A" v-model="accounts.accGroups.selected.info['task_able']">
<span style="color:#232F3A;margin-top:6px" slot="label">Используется для заданий</span>
</v-checkbox>

<v-checkbox @change="save('parser_able')" hide-details  color="#232F3A" v-model="accounts.accGroups.selected.info['parser_able']">
<span style="color:#232F3A;margin-top:6px" slot="label">Используется для парсера</span>
</v-checkbox>

</b-tab>


<!--Общая информация-->
<b-tab>
<template #title>
<v-icon small color="brown">mdi-information</v-icon> <strong style="margin-left:5px">Общая информация</strong>
</template>
</b-tab>

</b-tabs>


</v-card-text>
</v-card>
</v-dialog>
</template>

<script>

import axios from 'axios'
export default {
props:['accounts'],
data () {
return {
sb:{
sb:false,
color:"green",
text:"",
},
disabled:{
pass:false
},

search: '',
headers: [
{ text: 'Название', align: 'left', sortable: false, value: 'name'},
{ text: 'Максимальный лимит', value: 'max',sortable: false,  },
{ text: 'Счетчик', value: 'counter',sortable: false, },
{ text: 'Персональный лимит', value: 'limit',sortable: false, },
{ text: 'Лимит на действие до', value: 'expire',sortable: false, },
],
desserts: [],
}
},
methods:{
save(mode){
//this.accounts.accGroups.selected
console.log(this.accounts.accGroups.selected)
this.disabled.pass = true
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/ch_params.php', {
method: 'POST',
data: {
user: this.accounts.accGroups.selected,
mode:mode
}
}).then(response => {
this.disabled.pass = false
this.sb.sb = true
this.sb.color = "green"
this.sb.text = response.data.text
})
},


},
created(){

 let data = [
{
           name: 'Сообщения',
           max:   this.accounts.accGroups.selectedLimits.messageSend.max,
           limit: this.accounts.accGroups.selectedLimits.messageSend.limit,
           counter: this.accounts.accGroups.selectedLimits.messageSend.counter,
           expire: this.accounts.accGroups.selectedLimits.messageSend.expire,
},
{
           name: 'Заявки в друзья',
           max: this.accounts.accGroups.selectedLimits.friendRequest.max,
           limit: this.accounts.accGroups.selectedLimits.friendRequest.limit,
           counter: this.accounts.accGroups.selectedLimits.friendRequest.counter,
           expire: this.accounts.accGroups.selectedLimits.friendRequest.expire,
},
{
           name: 'Посты',
           max: this.accounts.accGroups.selectedLimits.postSend.max,
           limit: this.accounts.accGroups.selectedLimits.postSend.limit,
           counter: this.accounts.accGroups.selectedLimits.postSend.counter,
           expire: this.accounts.accGroups.selectedLimits.postSend.expire,
},
{
           name: 'Комментария',
           max: this.accounts.accGroups.selectedLimits.commentSend.max,
           limit: this.accounts.accGroups.selectedLimits.commentSend.limit,
           counter: this.accounts.accGroups.selectedLimits.commentSend.counter,
           expire: this.accounts.accGroups.selectedLimits.commentSend.expire,
},
{
           name: 'Создания обсуждений',
           max: this.accounts.accGroups.selectedLimits.topicCreate.max,
           limit: this.accounts.accGroups.selectedLimits.topicCreate.limit,
           counter: this.accounts.accGroups.selectedLimits.topicCreate.counter,
           expire: this.accounts.accGroups.selectedLimits.topicCreate.expire,
},
{
           name: 'Комментария обсуждений',
           max: this.accounts.accGroups.selectedLimits.topicComment.max,
           limit: this.accounts.accGroups.selectedLimits.topicComment.limit,
           counter: this.accounts.accGroups.selectedLimits.topicComment.counter,
           expire: this.accounts.accGroups.selectedLimits.topicComment.expire,
},
{
           name: 'Лайки',
           max: this.accounts.accGroups.selectedLimits.addLike.max,
           limit: this.accounts.accGroups.selectedLimits.addLike.limit,
           counter: this.accounts.accGroups.selectedLimits.addLike.counter,
           expire: this.accounts.accGroups.selectedLimits.addLike.expire,
},
{
           name: 'Вступление в сообщества',
           max: this.accounts.accGroups.selectedLimits.getInPublic.max,
           limit: this.accounts.accGroups.selectedLimits.getInPublic.limit,
           counter: this.accounts.accGroups.selectedLimits.getInPublic.counter,
           expire: this.accounts.accGroups.selectedLimits.getInPublic.expire,
},
]
this.desserts = data

},
filters:{
dateFormat(item){
var months = ['Янв.','Фев.','Мар.','Апр.','Мая','Июнь.','Июль.','Авг.','Сен.','Окт.','Ноя.','Дек.'];
let d =  new Date(item * 1000)
return  d.getDate()+" "+months[d.getMonth()]+"  "+ d.getHours() +":"+ d.getMinutes()
}
},
}
</script>

<style   >

</style>
